import { useContext, useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { RaceClass } from '../../../../constants/Regulation';
import StartNumbersContext from '../../../../contexts/StartNumbersContext';

const RaceClassAdder = (props) => {
  const selectRef = useRef();
  const [isActive, setIsActive] = useState(false);
  const { startNumberGroups, availableRaceClasses } = useContext(StartNumbersContext);

  const handleChange = (ev) => {
    setIsActive(false);
    const raceClass = Object.values(RaceClass).find(
      (raceClass) => raceClass.Id === ev.target.value
    );
    props.onAdd(raceClass);
  };

  useEffect(() => {
    if (!isActive) return;
    selectRef.current.focus();
  }, [isActive]);

  const getUnusedRaceClasses = () => {
    const selectedRaceClasses = startNumberGroups.flatMap(
      (group) => group.raceClasses
    );
  
    const allRaceClasses = Object.values(RaceClass);
  
    // Exclude classes that are not included in competition settings
    const availableRaceClassObjects = availableRaceClasses.map((classId) =>
      allRaceClasses.find((raceClass) => raceClass.Id === classId)
    );
  
    const unusedRaceClasses = availableRaceClassObjects.filter(
      (raceClass) => !selectedRaceClasses?.includes(raceClass)
    );
  
    return unusedRaceClasses;
  };

  return isActive ? (
    <Form.Select
      ref={selectRef}
      onChange={handleChange}
      onBlur={() => setIsActive(false)}
      className='w-auto py-1'
      style={{ border: 0, borderRadius: 0 }}
    >
      <option>Välj en klass</option>
      {getUnusedRaceClasses().map((raceClass) => (
        <option key={raceClass.Id} value={raceClass.Id}>
          {raceClass.Label}
        </option>
      ))}
    </Form.Select>
  ) : (
    <button
      onClick={() => setIsActive(true)}
      className='material-symbols-outlined border-0 p-1 bg-light'
      style={{ display: !isActive ? 'inline-block' : 'none' }}
    >
      add
    </button>
  );
};

export default RaceClassAdder;
